// Un seul calendrier (D-115) : la saison FFBB, du 1er juillet au 30 juin, pour l'abonnement, les groupes de
// bénévoles et les statistiques de la saison (badges, visibilité des partenaires). Même règle que la base
// (_season_start). Le club garde ses dates d'activité : sa saison sportive (équipes, licences) a les siennes.
// Fonctions pures (testées).

/** La saison FFBB d'un jour (« AAAA-MM-JJ ») : son nom et ses bornes (1er juillet → 30 juin). */
export function seasonOf(day: string): { name: string; from: string; to: string } {
  const y = Number(day.slice(0, 4)), m = Number(day.slice(5, 7));
  const s = m >= 7 ? y : y - 1;
  return { name: `${s}-${s + 1}`, from: `${s}-07-01`, to: `${s + 1}-06-30` };
}

/** La saison qui suit (« 2026-2027 » → « 2027-2028 »). */
export const seasonAfter = (name: string): string => { const s = Number(name.slice(0, 4)) + 1; return `${s}-${s + 1}`; };

/** Le dernier jour d'une saison nommée (« 2026-2027 » → « 2027-06-30 »). */
export const seasonLastDay = (name: string): string => `${name.slice(5, 9)}-06-30`;
